const LBS_TO_KG_COEFFICIENT = 2.205
const FT_TO_METERS_COEFFICIENT = 3.281
const FT_TO_CM_COEFFICIENT = 30.48
const CM_TO_METERS_COEFFICIENT = 100

export const lbsToKg = value => {
  return value / LBS_TO_KG_COEFFICIENT
}

export const kgToLbs = value => {
  return value * LBS_TO_KG_COEFFICIENT
}

export const cmToMeters = value => {
  return value / CM_TO_METERS_COEFFICIENT
}

export const ftToMeters = value => {
  return value / FT_TO_METERS_COEFFICIENT
}

export const ftToCm = value => {
  return value * FT_TO_CM_COEFFICIENT
}